'use client';

import { CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { addBtn, addBtnGrey2, SleepGraphResp } from './icons';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './MobileSleepComponent.module.css';

export const MobileSleepComponent = ({
  className,
  handleSleepScore,
  handleSleepStage,
  handleSleepContributor,
  handleAdvancedMetrics,
}: {
  className?: string;
  handleSleepScore?: any;
  handleSleepStage?: any;
  handleSleepContributor?: any;
  handleAdvancedMetrics?: any;
}) => {
  const t = useTranslations('ring');
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div className="head">
        <h2>
          {/* Sleep better <br /> than ever before */}
          {t('ring.bentoSleepSection.head.a')}
          <br />
          {t('ring.bentoSleepSection.head.b')}
        </h2>
        <p>{t('ring.bentoSleepSection.subhead')}</p>
      </div>
      <div className="sleep-items-container u-hide-scrollbar">
        <div className="items">
          <div
            className="item score"
            style={
              {
                '--score-bg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/sleepScoreBg.png/w_900',
                )})`,
              } as CSSProperties
            }
          >
            <div className="content">
              <h4> {t('ring.bentoSleepSection.sleepCard.title')}</h4>
              <h3> {t('ring.bentoSleepSection.sleepCard.subtitle')}</h3>
              <div className="img-container">
                <Image
                  src={'web_v2/ring-buy/sleep/svg/sleepIndexResp.svg'}
                  fill
                  alt="sleep-index"
                  className="sleep-index"
                />
              </div>
            </div>
            <button className="expand" onClick={handleSleepScore}>
              {addBtnGrey2}
            </button>
          </div>
          <div className="item contributors">
            <div className="content">
              <h4>
                {' '}
                {t('ring.bentoSleepSection.sleepContributorsCard.title')}
              </h4>
              <h3>
                {t('ring.bentoSleepSection.sleepContributorsCard.subtitleA')}
                <br />{' '}
                {t('ring.bentoSleepSection.sleepContributorsCard.subtitleB')}
              </h3>
              <div className="img-container">
                <Image
                  src={'web_v2/ring-buy/sleep/png/contributor_res.png'}
                  fill
                  alt="contributor-img"
                  className="contributorImg"
                />
              </div>
            </div>
            <button className="expand" onClick={handleSleepContributor}>
              {addBtn}
            </button>
          </div>
          <div className="item stages">
            <div className="content">
              <h4>{t('ring.bentoSleepSection.sleepStagesCard.title')}</h4>
              <h3>{t('ring.bentoSleepSection.sleepStagesCard.subtitleA')}</h3>
              <div className="sleep-graph">{SleepGraphResp}</div>
            </div>
            <button className="expand" onClick={handleSleepStage}>
              {addBtnGrey2}
            </button>
          </div>
          <div className="item metrics">
            <div className="content">
              <h4>{t('ring.bentoSleepSection.advancedMetricsCard.title')}</h4>
              <h3>
                {t('ring.bentoSleepSection.advancedMetricsCard.subtitleA')}
                <br />{' '}
                {t('ring.bentoSleepSection.advancedMetricsCard.subtitleB')}
              </h3>
            </div>
            <div className="img-container">
              <Image
                src={'web_v2/ring-buy/sleep/png/lonngevityBg.png'}
                fill
                alt="longevity-img"
                className="longevity"
              />
            </div>
            <button className="expand" onClick={handleAdvancedMetrics}>
              {addBtnGrey2}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
